import React from "react";
import DocView from "../../Images/UserProfileImg/docViewArrow.png";
import "../Styles/TravelConfirmation.css";

const TravelConfirmation = ({ trip }) => {
  // console.log(trip);
  return (
    <div className="container agreement-container1">
      <h2>Travel Confirmation</h2>
      <section className="section-agreement1">
        {!trip ? (
          <p style={{ margin: "6rem", color: "black" }}>Loading...</p>
        ) : (
          trip?.map((item, index) => {
            console.log(item);
            return (
              <div key={index} className="row my-3">
                <div className="agreement-row-wrap1">
                  <span className="col-doc1">{item?.title}</span>
                  <div className="agreement-docs1">
                    <a
                      target="_blank"
                      // href={item?.document?.link}
                      href={
                        item?.document_link?.includes("https://")
                          ? item?.document_link
                          : "https://" + item?.document_link
                      }
                      className="col-doc-view1"
                      style={{ textDecoration: "none" }}
                    >
                      View{" "}
                    </a>
                    <img src={DocView} alt="" />
                  </div>
                </div>
              </div>
            );
          })
        )}
        {/* <div className="row my-3">
          <div className="agreement-row-wrap1">
            <span className="col-doc1">Document Title 1</span>
            <div className="agreement-docs1">
              <span className="col-doc-view1">View </span>
              <img src={DocView} alt="" />
            </div>
          </div>
        </div>
        <div className="row my-3">
          <div className="agreement-row-wrap1">
            <span className="col-doc1">Document Title 1</span>
            <div className="agreement-docs1">
              <span className="col-doc-view1">View </span>
              <img src={DocView} alt="" />
            </div>
          </div>
        </div> */}
      </section>
    </div>
  );
};

export default TravelConfirmation;
